<!--  -->
<template>
  <div>
    <marquee class="notice" scrollamount="5" v-if="noticeTop.length>0">
      <span v-for="(item,index) in noticeTop" :key="index">
        {{'● '+item}}
      </span>
    </marquee>
  </div>
</template>

<script>
import { noticeList } from '../../api/api'
import { MessageBox } from 'mint-ui';

export default {
  data () {
    return {
      noticeTop:[],
      noticeCenter:[]
    };
  },
  mounted() {
    let that = this
    window.addEventListener("setItemEvent", function (e) {
        //监听key为cityOption的localstorage变化
      if(e.key === 'cityOption'){
        that.getNoticeList(JSON.parse(e.newValue))
      }
    });
  },
  methods: {
    showNoticeCenter(index){
        MessageBox('提示', this.noticeCenter[index]).then(isConfim => {
          index++
          if(index < this.noticeCenter.length){
            this.showNoticeCenter(index)
          }else{
            return
          }
        })
      },
      getNoticeList(cityOption){
        let show_page = window.location.href.split("#/")[1]
        if(show_page.indexOf("?") != -1){
          show_page = show_page.split('?')[0]
        }
        let parmas = {
          city_code :cityOption.id,
          show_page :show_page
        }
        noticeList(parmas).then(res => {
					if (res.data.code === 0) {
            let data = res.data.data
            this.noticeTop = []
            this.noticeCenter = []
            for(let item of data){
              if(item.show_type == 1){
                this.noticeTop.push(item.content)
              }else{
                this.noticeCenter.push(item.content)
              }
            }
            if(this.noticeCenter.length>0){
              this.showNoticeCenter(0)
            }
					}
				})
      },
  }
}

</script>
<style lang='scss' scoped>
.notice{
  height:1.3rem;
  line-height: 1.3rem;
  background: #FDF5E6;
  color: #ee7700;
  font-size: 0.6rem;
  display: block;
  span{
    margin-right: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// notice.vue?5dc6325e